module.exports = __webpack_public_path__ + "img/1_017.d2553572.jpg";